/* Collapsible description.

   The collapsed state is applied here rather than in CSS, so that if this
   script never runs the full description stays readable instead of being
   permanently clipped. The toggle only appears when the content is actually
   taller than the limit. */
(function () {
  'use strict';

  function setup(root) {
    if (root.__tsMore) return;
    root.__tsMore = true;

    var body = root.querySelector('[data-ts-more-body]');
    var toggle = root.querySelector('[data-ts-more-toggle]');
    var label = root.querySelector('[data-ts-more-label]');
    var labelLess = root.querySelector('[data-ts-more-label-less]');
    if (!body || !toggle) return;

    var max = parseInt(
      window.getComputedStyle(root).getPropertyValue('--ts-more-max'),
      10
    ) || 260;

    // Nothing to fold: leave the description alone and hide the control.
    if (body.scrollHeight <= max + 24) {
      toggle.hidden = true;
      root.classList.add('is-short');
      return;
    }

    root.classList.add('is-collapsed');

    toggle.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      root.classList.toggle('is-collapsed', !expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) label.hidden = expanded;
      if (labelLess) labelLess.hidden = !expanded;

      // Collapsing from far down the description would otherwise leave the
      // reader stranded below the fold.
      if (!expanded) {
        var top = root.getBoundingClientRect().top;
        if (top < 0) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }

      // Expanding can push the buy column past the viewport, at which point
      // sticky has to be given up.
      measureColumn();
    });
  }

  /* A sticky column taller than the space available cannot stick -- the
     browser scrolls it until its bottom edge arrives, which reads as the page
     refusing to scroll. When that happens, fall back to a static column so it
     scrolls with the page normally. */
  function measureColumn() {
    var col = document.querySelector('.product__info-container.sticky-element');
    if (!col) return;

    // Measure the natural height, not the height while the class is applied.
    col.classList.remove('ts-col-tall');
    var offset = parseFloat(getComputedStyle(col).top) || 0;
    var tall = col.getBoundingClientRect().height > window.innerHeight - offset - 16;
    col.classList.toggle('ts-col-tall', tall);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-ts-more]');
    Array.prototype.forEach.call(roots, setup);
  }

  function start(scope) {
    init(scope);
    measureColumn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  // Fonts and images change the measured height, so re-check after load.
  window.addEventListener('load', function () { start(); });
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });

  // Rotating a tablet or resizing the window changes whether the column fits.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureColumn, 150);
  });

  // The pack selector swaps variant content in and out, which changes height.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.ts-tiers')) {
      setTimeout(measureColumn, 60);
    }
  });
})();
